import React,{useEffect} from "react";
import css from "./HomeScreen.module.css";
import {AppIcon,BubblingView,FooterView,HeaderView} from "Components";
import {fadeIn} from "vritra";
import {useAppContext} from "Resources";


export default function HomeScreen(){
    const [context]=useAppContext();
    useEffect(()=>{
        const themeTag=document.querySelector(`meta[name="theme-color"]`);
        if(themeTag) themeTag.setAttribute("content",backgroundColor); 
        const contentEl=document.querySelector(`.${css.content}`);
        contentEl.style.opacity=0;
        fadeIn(contentEl,2000,()=>{
            contentEl.style.opacity=1;
        });
    },[context.theme]);
    return (
        <div key={context.theme} className={css.homescreen}>
            <HeaderView 
                className={css.header}
                showLibs="all" themerShown={true}
                searchBarShown={window.innerWidth>567}
            />
            <main className={css.content}>
                <AppIcon clickable={false} style={{fontSize:"4em"}}/>
                <p className={css.description}>{language.get("$appDescription")}</p>
                <a 
                    className={css.startbtn} 
                    href="#/getstarted"
                >{language.get("getStarted")}</a>
                <BubblingView/>
            </main>
            <FooterView className={css.footer}/>
        </div>
    )
}
